<template>
  <v-container class="minHeight" v-if="loaded">
    <first-teletag
      v-if="notFinishedRegister"
      @on-activated-first-tag="onActivatedFirstTag"
    >
    </first-teletag>

    <v-card v-else-if="!hasRows" class="py-4">
      <advice color="primary">
        <p v-html="$t('teletag.advice.nonTeletagActived')"></p>
        <v-btn
          outline
          round
          color="accent"
          class="initialize right"
          @click="
            isShowingGetTeletagBottomSheet = !isShowingGetTeletagBottomSheet
          "
        >
          {{ $t('teletag.button.button.get.teletag') }}</v-btn
        >

        <v-btn
          outline
          round
          color="primary"
          class="initialize right"
          @click="
            isShowingTeletagActivateBottomSheet =
              !isShowingTeletagActivateBottomSheet
          "
        >
          {{ $t('teletag.button.button.activate.teletag') }}</v-btn
        >
      </advice>
    </v-card>

    <v-card v-else>
      <v-layout>
        <v-flex>
          <v-btn
            outline
            round
            color="accent"
            class="initialize right"
            @click="
              isShowingGetTeletagBottomSheet = !isShowingGetTeletagBottomSheet
            "
          >
            {{ $t('teletag.button.button.get.teletag') }}</v-btn
          >
          <v-btn
            outline
            round
            color="primary"
            class="initialize right"
            @click="
              isShowingTeletagActivateBottomSheet =
                !isShowingTeletagActivateBottomSheet
            "
          >
            {{ $t('teletag.button.button.activate.teletag') }}</v-btn
          >
        </v-flex>
      </v-layout>

      <v-layout row class="pb-4">
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="teletags"
            hide-actions
            expand
            item-key="code"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.code }}</td>
              <td v-if="showPlate" class="text-xs-center">
                {{ props.item.plate }}
              </td>
              <td class="text-xs-center" v-if="$vuetify.breakpoint.mdAndUp">
                {{ props.item.activationDatePrettyString }}
              </td>
              <td class="justify-center layout px-0">
                <v-btn
                  icon
                  class="primary"
                  color="primary"
                  outline
                  v-if="showPlate"
                  @click="showEditTeletagBottomSheet(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="error"
                  color="error"
                  outline
                  @click="showTeletagDeleteDialog(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <delete-teletag
      :teletag="selectedTag"
      v-if="isShowingTeletagDeleteDialog"
      @on-success="getuserTeletags"
      @on-close="closeTeletagDeleteDialog"
    ></delete-teletag>

    <edit-teletag
      :teletag="selectedTag"
      v-if="isShowingEditTeletagBottomSheet"
      @on-success="getuserTeletags"
      @on-close="closeEditTeletagBottomSheet"
    ></edit-teletag>

    <choose-option-get-teletag
      v-if="isShowingGetTeletagBottomSheet"
      @on-close="closeGetTeletagBottomSheet"
    ></choose-option-get-teletag>

    <activate-teletag
      :showPlate="showPlate"
      v-if="isShowingTeletagActivateBottomSheet"
      @on-success="getuserTeletags"
      @on-close="closeTeletagActivateBottomSheet"
    ></activate-teletag>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import teletagService from '@/services/teletagService';
import ChooseOptionGetTeletag from '@/components/private/tag/ChooseOptionGetTeletag';
import DeleteTeletag from '@/components/private/tag/DeleteTeletag';
import EditTeletag from '@/components/private/tag/EditTeletag';
import FirstTeletag from '@/components/private/tag/FirstTeletag';
import ActivateTeletag from '@/components/private/tag/ActivateTeletag';
import Advice from '@/components/commons/Advice';
import manageErrorService from '@/services/manageErrorService';
import userService from '@/services/userService';
import store from '@/store';

export default {
  name: 'Teletags',
  components: {
    [ChooseOptionGetTeletag.name]: ChooseOptionGetTeletag,
    [DeleteTeletag.name]: DeleteTeletag,
    [ActivateTeletag.name]: ActivateTeletag,
    [EditTeletag.name]: EditTeletag,
    [FirstTeletag.name]: FirstTeletag,
    [Advice.name]: Advice,
  },
  computed: {
    showChooseOptionGetTeletag() {
      if (typeof this.$route.query.show !== 'undefined') {
        return this.$route.query.show;
      }
      return false;
    },
    headers() {
      let codePlateHeader = !this.showPlate
        ? [
            {
              i18nText: 'global.code',
              text: this.$i18n.t('global.code'),
              align: 'center',
              value: 'code',
            },
          ]
        : [
            {
              i18nText: 'global.code',
              text: this.$i18n.t('global.code'),
              align: 'center',
              value: 'code',
            },
            {
              i18nText: 'global.plate',
              text: this.$i18n.t('global.plate'),
              align: 'center',
              value: 'plate',
            },
          ];
      if (this.$vuetify.breakpoint.mdAndUp) {
        return codePlateHeader.concat([
          {
            i18nText: 'teletag.activation.date',
            text: this.$i18n.t('teletag.activation.date'),
            align: 'center',
            value: 'activationDatePrettyString',
          },
          {
            i18nText: '',
            text: '',
            align: 'right',
            value: '',
          },
        ]);
      } else {
        return codePlateHeader.concat([
          {
            i18nText: '',
            text: '',
            align: 'right',
            value: '',
          },
        ]);
      }
    },
    notFinishedRegister() {
      return userService.noActivated() || userService.sentLetter();
    },
    showPlate() {
      return !store.state.countrySelected.hasBle;
    },
  },
  data() {
    return {
      selectedTag: {},
      loaded: false,
      hasRows: false,
      isShowingGetTeletagBottomSheet: false,
      isShowingTeletagDeleteDialog: false,
      isShowingEditTeletagBottomSheet: false,
      isShowingTeletagActivateBottomSheet: false,
      teletags: [],
    };
  },
  created() {
    this.getuserTeletags();

    if (this.showChooseOptionGetTeletag) {
      this.isShowingGetTeletagBottomSheet = true;
    }
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     if (this.notFinishedRegister) {
  //       EventBus.$emit(keys.eventShowDrawer);
  //       //store.commit('CHANGE_TITLE_SECTION', { text: 'teletag.finishRegister.title' });
  //     }
  //   })
  // },
  methods: {
    onActivatedFirstTag() {
      this.getuserTeletags();
    },
    async getuserTeletags() {
      let params = {};
      let results = await teletagService.list(params);

      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.teletags = results.data;
      let timezone = store.state.countrySelected.timeZone;
      _.each(this.teletags, (itTeletag) => {
        itTeletag.activationDatePrettyString = '-';
        if (itTeletag.activationDate) {
          itTeletag.activationDatePrettyString = moment(
            itTeletag.activationDate
          )
            .utc()
            .tz(timezone)
            .format('L');
        }
      });

      if (this.teletags.length === 0) {
        this.hasRows = false;
      } else {
        this.hasRows = true;
      }
      this.loaded = true;
    },

    showTeletagDeleteDialog(item) {
      this.isShowingTeletagDeleteDialog = true;
      this.selectedTag = item;
    },
    closeTeletagDeleteDialog() {
      this.isShowingTeletagDeleteDialog = false;
    },

    showEditTeletagBottomSheet(item) {
      this.isShowingEditTeletagBottomSheet = true;
      this.selectedTag = item;
    },
    closeEditTeletagBottomSheet(item) {
      this.isShowingEditTeletagBottomSheet = false;
    },

    closeGetTeletagBottomSheet(item) {
      this.isShowingGetTeletagBottomSheet = false;
    },

    closeTeletagActivateBottomSheet() {
      this.isShowingTeletagActivateBottomSheet = false;
    },
  },
};
</script>
